import { render, staticRenderFns } from "./FooterDateAt.vue?vue&type=template&id=6e5ce5e0"
import script from "./FooterDateAt.vue?vue&type=script&lang=js"
export * from "./FooterDateAt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports